/* eslint-disable id-length */
export enum EmployerChecklistCategory {
  A = 'A',
  B = 'B',
  C = 'C',
}
/* eslint-enable id-length */

export const EMPLOYER_CHECKLIST_CATEGORIES_I18N = {
  [EmployerChecklistCategory.A]: 'Gilt für A Positionen (PDL, EL, QB, SL, PD)',
  [EmployerChecklistCategory.B]: 'Gilt für die B, Stellvetrende A und D1 Positionen',
  [EmployerChecklistCategory.C]: 'Gilt für andere Positionen',
};
